import React, { useState, useEffect } from "react";
import { Card } from "primereact/card";
import DeviceService from "../DevicesService";
import ProjectService from "../../all-projects/ProjectService";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { FaEdit } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import i18n from "i18next";
import { useTranslation } from "react-i18next";

type AllDevices = {
  onNext: (device: any) => void;
};
const AllDevices = (props: AllDevices) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [userDetails, setUserDetails] = useState<any>();
  const [devices, setDevices] = useState<any>([]);
  const deviceService = new DeviceService();
  const projectService = new ProjectService();

  const status = (rowValue: any) => {
    const currentDate = new Date();
    const targetDate = new Date(rowValue['rent_to']);
    let div;
    if (rowValue["assigned"] && currentDate < targetDate) {
      div = <div className="green-circle ml-4"></div>;
    } else {
      div = <div className="red-circle ml-4"></div>;
    }
    return div;
  };

  const checkDid = (rowValue: any) =>{
    const currentDate = new Date();
    const targetDate = new Date(rowValue['rent_to']);
    if(currentDate < targetDate && rowValue['is_deleted'] === false) {
      return (
          <tr>{rowValue['did']}</tr>
      );
    }
    else if (rowValue['is_deleted']){
      return (
          <tr style={{color: 'red', fontWeight: '600', textDecoration: 'line-through'}}>{rowValue['did']}</tr>
      )
    }
    else{
      return (
          <tr style={{color: 'red', fontWeight: '600'}}>{rowValue['did']}</tr>
      )
    }
  }
  const checkRentFrom = (rowValue: any) =>{
    const currentDate = new Date();
    const targetDate = new Date(rowValue['rent_to']);
    if(currentDate < targetDate && rowValue['is_deleted'] === false){
      return(
          <tr>{rowValue['rent_from']}</tr>
      )
    }
    else if (rowValue['is_deleted']){
      return (
          <tr style={{color: 'red', fontWeight: '600', textDecoration: 'line-through'}}>{rowValue['did']}</tr>
      )
    }
    else{
      return (
          <tr style={{color: 'red', fontWeight: '600'}}>{rowValue['rent_from']}</tr>
      )
    }
  }
  const checkrentTo = (rowValue: any) =>{
    const currentDate = new Date();
    const targetDate = new Date(rowValue['rent_to']);
    if(currentDate < targetDate && rowValue['is_deleted'] === false) {
      return (
          <tr>{rowValue['rent_to']}</tr>
      );
    }
    else if (rowValue['is_deleted']){
      return (
          <tr style={{color: 'red', fontWeight: '600', textDecoration: 'line-through'}}>{rowValue['did']}</tr>
      )
    }
    else{
      return (
          <tr style={{color: 'red', fontWeight: '600'}}>{rowValue['rent_to']}</tr>
      )
    }
  }

  const edit = (rowValue: any) => {
    const currentDate = new Date();
    const targetDate = new Date(rowValue['rent_to']);
    if(currentDate < targetDate && rowValue['is_deleted'] === false) {
      return (
          <FaEdit
              className="edit-icon mx-2"
              onClick={() => {
                if (rowValue["projectName"] !== "----") {
                  navigate(
                      "/device/" + rowValue["did"] + "/" + rowValue["projectName"]
                  );
                  props.onNext(rowValue);
                } else {
                  navigate("/all-devices");
                  props.onNext(rowValue);
                }
              }}
          />
      );
    }
  };
  useEffect(() => {
    i18n.changeLanguage(localStorage.getItem("lang")!);

    projectService.getUserDetails().then((response) => {
      setUserDetails(response);
      deviceService.getDevicesList(response["id"]).then((response) => {
        setDevices(response);
      });
    });
  }, [i18n.language]);
  return (
    <>
      <Card
        title={t("all_available_devices")}
        className="InputForms_container mt-4"
      >
        <div className="card">
          <DataTable value={devices} responsiveLayout="scroll">
            <Column field="did" body={checkDid} header={t("serial_no")} />
            <Column field="rent_from" body={checkRentFrom} header={t("renting_from")} />
            <Column field="rent_to" body={checkrentTo} header={t("renting_to")} />
            <Column field="station" header={t("station")} />
            <Column field="projectName" header={t("project_name")} />
            <Column field="assigned" header={t("assign")} body={status} />
            <Column field="edit" header={t("options")} body={edit} />
          </DataTable>
        </div>
      </Card>
    </>
  );
};

export default AllDevices;
